/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { Input } from 'components/Input';
import { Button } from 'components/Button';

import { useSnackbar } from 'notistack';

import { COLOR } from 'assets/styles/colors';
import ReloadIcon from 'assets/icons/SvgIcons/Reload';

import SnackMessage, { OPTIONS } from 'components/SnackMessage';
import { ALERT_TYPE } from 'components/Alert';

import {
  Wrapper,
  ReloadButton,
  Box, InputWrapper,
  QRBox, ButtonWrapper,
} from './styles';
import { Cards, BoxOptin } from '../styles';

const PixSection = ({
  loading,
  reload,
  pix, checked, handleCheck,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(pix.qrcode);

    enqueueSnackbar('Código PIX copiado com sucesso!', {
      ...OPTIONS,
      content: (key, message) => (
        <SnackMessage
          id={key}
          message={message}
          variant={ALERT_TYPE.SUCCESS}
        />
      ),
    });
  };

  return (
    <Cards style={{ padding: '32px 0' }}>
      <h2>Leia e assinale o campo abaixo para gerar o código de pagamento por PIX</h2>
      <BoxOptin>
        <Checkbox
          size="small"
          id="disclaimer"
          checked={checked}
          onChange={handleCheck}
        />
        <label
          htmlFor="disclaimer"
          style={{ cursor: 'pointer' }}
        >
          Concordo que os meus extratos estão corretos e que
          {' '}
          <strong>NÃO</strong>
          {' '}
          será possível alterá-los após a compra do KIT.
        </label>
      </BoxOptin>
      <h2>Copie o código PIX para usar no aplicativo do seu banco:</h2>
      <form onSubmit={handleCopy}>
        <InputWrapper>
          <Input
            disabled={!checked}
            value={checked ? pix.qrcode : ''}
          />
          <Button
            disabled={!checked}
            type="submit"
          >
            Copiar
          </Button>
        </InputWrapper>
      </form>
      <p style={{
        fontSize: 16, textAlign: 'left', lineHeight: '125%', marginBottom: 32,
      }}
      >
        Em seguida abra o aplicativo do seu banco, selecione a opção “PIX - Copia e cola” (Pagar com código) e cole o código para prosseguir com o pagamento
      </p>
      <Box>
        <h2 style={{ textAlign: 'center' }}>
          Ou abra o aplicativo do seu banco, escolha a opção “PIX - pagar QR Code” e aponte a câmera para o código abaixo:
        </h2>
        <Wrapper>
          {
            checked && pix.qrimage
              ? (
                <img
                  alt="QR Code"
                  src={pix.qrimage}
                  style={{ width: 100 }}
                />
              )
              : (<QRBox />)
          }
          <ReloadButton
            disabled={!checked || loading}
            onClick={() => reload(true)}
            type="button"
          >
            <ReloadIcon color={!checked || loading ? COLOR.GREY_3 : COLOR.GREEN_1} />
            Atualizar
          </ReloadButton>
        </Wrapper>
      </Box>
      <ButtonWrapper>
        <Link
          to="home"
        >
          <Button
            variant="outlined"
            className="unset"
          >
            Voltar
          </Button>
        </Link>
      </ButtonWrapper>
    </Cards>
  );
};

PixSection.propTypes = {
  pix: PropTypes.exact({
    qrcode: PropTypes.string,
    qrimage: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  reload: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  handleCheck: PropTypes.func.isRequired,
};

export default PixSection;
